import React, { useState, useEffect } from 'react';
import {
  FiUser, FiEdit2, FiSave, FiX, FiCamera, FiMail,
FiMapPin, FiLink,  FiBell,
 FiShield, FiGlobe, FiDatabase, FiAward,
  FiBook, FiCalendar, FiStar, FiSettings, FiPlus, FiTrash2
} from 'react-icons/fi';
import { FaCrown } from 'react-icons/fa';  
import './Profile.css';



const Profile = () => {
  const [userData, setUserData] = useState({
    name: 'Shivang Patel',
    email: 'shivangpatel2050@gmail.com',
    title: 'Founding Engineer ',
    location: 'Charlotte, North Carolina ',
    bio: 'Passionate about creating innovative solutions that make education more accessible and engaging. Currently focused on developing platforms that help students succeed.',
    website: '',
    phone: 'shivangpatII',
    university: 'Ardrey Kell ',
    major: 'Computer Science',
    graduationYear: '2028',
    gpa: '4.45'
  });

  const [preferences, setPreferences] = useState({
    emailNotifications: true,
    pushNotifications: false,
    language: 'en',
    timezone: 'EST',
    theme: 'light'
  });

  const [academicInfo, setAcademicInfo] = useState({
    courses: ['Advanced Algorithms', 'Machine Learning', 'Data Structures', 'Web Development'],
    skills: ['JavaScript', 'Python', 'React', 'Node.js', 'TensorFlow', 'Leadership'],
    achievements: ['Varisty Nation Level Jumper Track', '', '', 'Founding Engineer']
  });

  const [isEditing, setIsEditing] = useState(false);
  const [isEditingAcademic, setIsEditingAcademic] = useState(false);
  const [tempData, setTempData] = useState({});
  const [tempAcademicData, setTempAcademicData] = useState({});
  const [activeTab, setActiveTab] = useState('profile');
  const [newCourse, setNewCourse] = useState('');
  const [newSkill, setNewSkill] = useState('');
  const [newAchievement, setNewAchievement] = useState('');
  const [isFounder, setIsFounder] = useState(false);

  useEffect(() => {
    // Load user data from localStorage
    const savedData = localStorage.getItem('studentProfile');
    if (savedData) {
      setUserData(JSON.parse(savedData));
    }
    
    const savedPrefs = localStorage.getItem('studentPreferences');
    if (savedPrefs) {
      setPreferences(JSON.parse(savedPrefs));
    }

    const savedAcademic = localStorage.getItem('studentAcademic');
    if (savedAcademic) {
      setAcademicInfo(JSON.parse(savedAcademic));
    }

    const userEmail = localStorage.getItem('userEmail') || 'guest@example.com';
    setIsFounder(userEmail === 'shivangpatel2050@gmail.com');
  }, []);

  const handleEdit = () => {
    if (!isFounder) return;
    setTempData(userData);
    setIsEditing(true);
  };

  const handleEditAcademic = () => {
    if (!isFounder) return;
    setTempAcademicData({...academicInfo});
    setIsEditingAcademic(true);
  };

  const handleSave = () => {
    setUserData(tempData);
    localStorage.setItem('studentProfile', JSON.stringify(tempData));
    setIsEditing(false);
  };

  const handleSaveAcademic = () => {
    setAcademicInfo(tempAcademicData);
    localStorage.setItem('studentAcademic', JSON.stringify(tempAcademicData));
    setIsEditingAcademic(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleCancelAcademic = () => {
    setIsEditingAcademic(false);
  };

  const handleInputChange = (field, value) => {
    setTempData({
      ...tempData,
      [field]: value
    });
  };

  const handleAcademicArrayChange = (field, index, value) => {
    const updatedArray = [...tempAcademicData[field]];
    updatedArray[index] = value;
    setTempAcademicData({
      ...tempAcademicData,
      [field]: updatedArray
    });
  };

  const handleAddItem = (field, value, setValue) => {
    if (value.trim()) {
      setTempAcademicData({
        ...tempAcademicData,
        [field]: [...tempAcademicData[field], value.trim()]
      });
      setValue('');
    }
  };

  const handleRemoveItem = (field, index) => {
    const updatedArray = tempAcademicData[field].filter((_, i) => i !== index);
    setTempAcademicData({
      ...tempAcademicData,
      [field]: updatedArray
    });
  };

  const handlePreferenceChange = (field, value) => {
    if (!isFounder) return;
    const newPreferences = {
      ...preferences,
      [field]: value
    };
    setPreferences(newPreferences);
    localStorage.setItem('studentPreferences', JSON.stringify(newPreferences));
  };

  const handleAvatarUpload = (e) => {
    if (!isFounder) return;
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const updatedData = {
          ...userData,
          avatar: event.target.result
        };
        setUserData(updatedData);
        localStorage.setItem('studentProfile', JSON.stringify(updatedData));
      };
      reader.readAsDataURL(file);
    }
  };

  const renderProfileTab = () => (
    <div className="profile-section">
      <div className="avatar-section">
        <div className="avatar-container">
          <img 
            src={userData.avatar || 'https://media.licdn.com/dms/image/v2/D5603AQFhTBGOfl5wTw/profile-displayphoto-crop_800_800/B56ZhY4ePEHMAM-/0/1753837856600?e=1759363200&v=beta&t=63zh7Ytp5bKa6niI0umE3t-BymrQ8WL76S1JwyD4V6E'} 
            alt="Profile" 
            className="avatar"
          />
          {isFounder && (
            <label htmlFor="avatar-upload" className="avatar-upload">
              <FiCamera />
              <input 
                id="avatar-upload" 
                type="file" 
                accept="image/*" 
                onChange={handleAvatarUpload} 
              />
            </label>
          )}
        </div>
        <h2>{userData.name}</h2>
        <p>{userData.title}</p>
        {isFounder && (
          <div className="founder-badge">
            <FaCrown /> Founder Account
          </div>
        )}
      </div>

      <div className="profile-details">
        {isEditing ? (
          <>
            <div className="form-group">
              <label>Name</label>
              <input 
                type="text" 
                value={tempData.name} 
                onChange={(e) => handleInputChange('name', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input 
                type="email" 
                value={tempData.email} 
                onChange={(e) => handleInputChange('email', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Title</label>
              <input 
                type="text" 
                value={tempData.title} 
                onChange={(e) => handleInputChange('title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input 
                type="text" 
                value={tempData.location} 
                onChange={(e) => handleInputChange('location', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>University</label>
              <input 
                type="text" 
                value={tempData.university} 
                onChange={(e) => handleInputChange('university', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Major</label>
              <input 
                type="text" 
                value={tempData.major} 
                onChange={(e) => handleInputChange('major', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Graduation Year</label>
              <input 
                type="text" 
                value={tempData.graduationYear} 
                onChange={(e) => handleInputChange('graduationYear', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>GPA</label>
              <input 
                type="text" 
                value={tempData.gpa} 
                onChange={(e) => handleInputChange('gpa', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Website</label>
              <input 
                type="url" 
                value={tempData.website} 
                onChange={(e) => handleInputChange('website', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Bio</label>
              <textarea 
                value={tempData.bio} 
                onChange={(e) => handleInputChange('bio', e.target.value)}
                rows="4"
              />
            </div>
            <div className="form-actions">
              <button className="btn-primary" onClick={handleSave}>
                <FiSave /> Save Changes
              </button>
              <button className="btn-secondary" onClick={handleCancel}>
                <FiX /> Cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="info-item">
              <FiMail className="info-icon" />
              <div className="info-content">
                <span className="info-label">Email</span>
                <span className="info-value">{userData.email}</span>
              </div>
            </div>
            <div className="info-item">
              <FiMapPin className="info-icon" />
              <div className="info-content">
                <span className="info-label">Location</span>
                <span className="info-value">{userData.location}</span>
              </div>
            </div>
            <div className="info-item">
              <FiBook className="info-icon" />
              <div className="info-content">
                <span className="info-label">University</span>
                <span className="info-value">{userData.university}</span>
              </div>
            </div>
            <div className="info-item">
              <FiAward className="info-icon" />
              <div className="info-content">
                <span className="info-label">Major</span>
                <span className="info-value">{userData.major}</span>
              </div>
            </div>
            <div className="info-item">
              <FiCalendar className="info-icon" />
              <div className="info-content">
                <span className="info-label">Graduation Year</span>
                <span className="info-value">{userData.graduationYear}</span>
              </div>
            </div>
            <div className="info-item">
              <FiStar className="info-icon" />
              <div className="info-content">
                <span className="info-label">GPA</span>
                <span className="info-value">{userData.gpa}</span>
              </div>
            </div>
            <div className="info-item">
              <FiLink className="info-icon" />
              <div className="info-content">
                <span className="info-label">Website</span>
                <a href={userData.website} target="_blank" rel="noopener noreferrer" className="info-value">
                  {userData.website}
                </a>
              </div>
            </div>
            <div className="info-item">
              <div className="info-content">
                <span className="info-label">Bio</span>
                <p className="info-bio">{userData.bio}</p>
              </div>
            </div>
            {isFounder && (
              <button className="btn-primary" onClick={handleEdit}>
                <FiEdit2 /> Edit Profile
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );

  const renderAcademicTab = () => (
    <div className="academic-section">
      {isEditingAcademic ? (
        <>
          <h3>Current Courses</h3>
          <div className="editable-list">
            {tempAcademicData.courses.map((course, index) => (
              <div key={index} className="editable-item">
                <input
                  type="text"
                  value={course}
                  onChange={(e) => handleAcademicArrayChange('courses', index, e.target.value)}
                  className="edit-input"
                />
                <button 
                  onClick={() => handleRemoveItem('courses', index)}
                  className="remove-btn"
                >
                  <FiTrash2 />
                </button>
              </div>
            ))}
            <div className="add-item">
              <input
                type="text"
                value={newCourse}
                onChange={(e) => setNewCourse(e.target.value)}
                placeholder="Add new course"
                className="edit-input"
              />
              <button 
                onClick={() => handleAddItem('courses', newCourse, setNewCourse)}
                className="add-btn"
              >
                <FiPlus /> Add
              </button>
            </div>
          </div>

          <h3>Skills</h3>
          <div className="editable-list">
            {tempAcademicData.skills.map((skill, index) => (
              <div key={index} className="editable-item">
                <input
                  type="text"
                  value={skill}
                  onChange={(e) => handleAcademicArrayChange('skills', index, e.target.value)}
                  className="edit-input"
                />
                <button 
                  onClick={() => handleRemoveItem('skills', index)}
                  className="remove-btn"
                >
                  <FiTrash2 />
                </button>
              </div>
            ))}
            <div className="add-item">
              <input
                type="text"
                value={newSkill}
                onChange={(e) => setNewSkill(e.target.value)}
                placeholder="Add new skill"
                className="edit-input"
              />
              <button 
                onClick={() => handleAddItem('skills', newSkill, setNewSkill)}
                className="add-btn"
              >
                <FiPlus /> Add
              </button>
            </div>
          </div>

          <h3>Achievements</h3>
          <div className="editable-list">
            {tempAcademicData.achievements.map((achievement, index) => (
              <div key={index} className="editable-item">
                <input
                  type="text"
                  value={achievement}
                  onChange={(e) => handleAcademicArrayChange('achievements', index, e.target.value)}
                  className="edit-input"
                />
                <button 
                  onClick={() => handleRemoveItem('achievements', index)}
                  className="remove-btn"
                >
                  <FiTrash2 />
                </button>
              </div>
            ))}
            <div className="add-item">
              <input
                type="text"
                value={newAchievement}
                onChange={(e) => setNewAchievement(e.target.value)}
                placeholder="Add new achievement"
                className="edit-input"
              />
              <button 
                onClick={() => handleAddItem('achievements', newAchievement, setNewAchievement)}
                className="add-btn"
              >
                <FiPlus /> Add
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button className="btn-primary" onClick={handleSaveAcademic}>
              <FiSave /> Save Academic Info
            </button>
            <button className="btn-secondary" onClick={handleCancelAcademic}>
              <FiX /> Cancel
            </button>
          </div>
        </>
      ) : (
        <>
          <h3>Current Courses</h3>
          <div className="courses-grid">
            {academicInfo.courses.map((course, index) => (
              <div key={index} className="course-card">
                <div className="course-name">{course}</div>
                <div className="course-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{width: `${70 + index * 10}%`}}></div>
                  </div>
                  <span className="progress-text">{70 + index * 10}% complete</span>
                </div>
              </div>
            ))}
          </div>

          <h3>Skills</h3>
          <div className="skills-container">
            {academicInfo.skills.map((skill, index) => (
              <span key={index} className="skill-tag">{skill}</span>
            ))}
          </div>

          <h3>Achievements</h3>
          <div className="achievements-list">
            {academicInfo.achievements.map((achievement, index) => (
              <div key={index} className="achievement-item">
                <FiAward className="achievement-icon" />
                <span>{achievement}</span>
              </div>
            ))}
          </div>

          {isFounder && (
            <button className="btn-primary" onClick={handleEditAcademic}>
              <FiEdit2 /> Edit Academic Info
            </button>
          )}
        </>
      )}
    </div>
  );

  const renderPreferencesTab = () => (
    <div className="preferences-section">
      {!isFounder ? (
        <div className="view-only-message">
          <FiShield size={48} />
          <h3>Restricted Access</h3>
          <p>Only the founder can modify preferences and settings.</p>
        </div>
      ) : (
        <>
          <h3>Notification Preferences</h3>
          <div className="preference-item">
            <div className="preference-info">
              <FiMail className="preference-icon" />
              <div>
                <div className="preference-label">Email Notifications</div>
                <div className="preference-description">Receive updates via email</div>
              </div>
            </div>
            <label className="toggle-switch">
              <input 
                type="checkbox" 
                checked={preferences.emailNotifications} 
                onChange={(e) => handlePreferenceChange('emailNotifications', e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="preference-item">
            <div className="preference-info">
              <FiBell className="preference-icon" />
              <div>
                <div className="preference-label">Push Notifications</div>
                <div className="preference-description">Receive browser notifications</div>
              </div>
            </div>
            <label className="toggle-switch">
              <input 
                type="checkbox" 
                checked={preferences.pushNotifications} 
                onChange={(e) => handlePreferenceChange('pushNotifications', e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>

          <h3>Appearance</h3>
          <div className="preference-item">
            <div className="preference-info">
              <FiGlobe className="preference-icon" />
              <div>
                <div className="preference-label">Language</div>
                <div className="preference-description">Interface language</div>
              </div>
            </div>
            <select 
              value={preferences.language} 
              onChange={(e) => handlePreferenceChange('language', e.target.value)}
              className="language-select"
            >
              <option value="en">English</option>
              <option value="es">Español</option>
              <option value="fr">Français</option>
              <option value="de">Deutsch</option>
            </select>
          </div>

          <div className="preference-item">
            <div className="preference-info">
              <FiDatabase className="preference-icon" />
              <div>
                <div className="preference-label">Theme</div>
                <div className="preference-description">Interface appearance</div>
              </div>
            </div>
            <select 
              value={preferences.theme} 
              onChange={(e) => handlePreferenceChange('theme', e.target.value)}
              className="theme-select"
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
              <option value="auto">Auto (System)</option>
            </select>
          </div>
        </>
      )}
    </div>
  );

  return (
    <div className="profile-page">
      <div className="profile-header">
        <h1>
          {isFounder ? <FiUser /> : <FaCrown />} 
          {isFounder ? 'My Profile' : 'About the Founder'}
        </h1>
        <p>
          {isFounder 
            ? 'Manage your academic profile and preferences' 
            : 'Learn more about the creator of this platform'
          }
        </p>
      </div>

      <div className="profile-container">
        <div className="profile-sidebar">
          <div 
            className={`sidebar-item ${activeTab === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            <FiUser /> {isFounder ? 'Personal Info' : 'About'}
          </div>
          <div 
            className={`sidebar-item ${activeTab === 'academic' ? 'active' : ''}`}
            onClick={() => setActiveTab('academic')}
          >
            <FiBook /> {isFounder ? 'Academic' : 'Background'}
          </div>
          {isFounder && (
            <div 
              className={`sidebar-item ${activeTab === 'preferences' ? 'active' : ''}`}
              onClick={() => setActiveTab('preferences')}
            >
              <FiSettings /> Preferences
            </div>
          )}
        </div>

        <div className="profile-content">
          {activeTab === 'profile' && renderProfileTab()}
          {activeTab === 'academic' && renderAcademicTab()}
          {activeTab === 'preferences' && renderPreferencesTab()}
        </div>
      </div>
    </div>
  );
};

export default Profile;